import { Node } from "@tiptap/react"

/**
 * Un salto de página explícito dentro del documento.
 *
 * ⚠ **Existe porque la impresión del navegador es el exportador a PDF.** Sin un salto
 * que se pueda poner a mano, una tabla de procedimiento se parte por la mitad entre
 * dos hojas y no hay forma de arreglarlo desde la pantalla. En papel eso deja un
 * documento controlado con la cabecera en una hoja y las filas en la siguiente.
 *
 * En pantalla se pinta como una línea de puntos; al imprimir fuerza hoja nueva. Lo
 * hace el CSS con `break-after: page`, no este archivo: aquí sólo vive el nodo.
 *
 * ⚠ **Sin comando propio.** Se inserta con `insertContent({ type: "saltoDePagina" })`
 * desde la barra. Declarar un comando a medida obliga a extender los tipos de TipTap
 * con `declare module`, y es mucha maquinaria para un botón.
 */

export const SaltoDePagina = Node.create({
  name: "saltoDePagina",
  group: "block",
  // Sin contenido: es una marca, no un contenedor. Con contenido, el cursor podría
  // entrar dentro del salto y escribir texto que no se ve en ningún sitio.
  atom: true,
  selectable: true,

  parseHTML() {
    return [{ tag: 'div[data-salto-de-pagina="true"]' }]
  },

  renderHTML() {
    return ["div", { "data-salto-de-pagina": "true", class: "doc-salto" }]
  },
})
